import {signup_init} from "./features/cities";
import { videoPreview } from "./features/videoPreview";
import { ui } from "./utils/ui";

export default () => {
    signup_init()

    videoPreview(
        ui.testimonyVideo.inputUpload, 
        ui.testimonyVideo.videoElement, 
        ui.testimonyVideo.videoContainer, 
        ui.testimonyVideo.removeVideo, 
        ui.testimonyVideo.uploadContainer,
    )
}
